import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('firmpay_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('firmpay_token');
      localStorage.removeItem('firmpay_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    // Normalize FastAPI/Pydantic 422 detail (array of objects) into a readable string.
    // This prevents React "Objects are not valid as a React child" crashes when
    // callers do toast.error(err?.response?.data?.detail).
    const d = err?.response?.data?.detail;
    if (Array.isArray(d)) {
      err.response.data.detail = d
        .map((item) => {
          if (typeof item === 'string') return item;
          const loc = Array.isArray(item?.loc) ? item.loc.filter((x) => x !== 'body').join('.') : '';
          const msg = item?.msg || 'Error de validación';
          return loc ? `${loc}: ${msg}` : msg;
        })
        .join('; ');
    } else if (d && typeof d === 'object') {
      err.response.data.detail = d?.msg || d?.message || JSON.stringify(d);
    }
    return Promise.reject(err);
  }
);

export default api;
